module.exports = __webpack_public_path__ + "media/asset/images/crewwCoverImage-8c5a25a0962766629fa8316d96af947e.png";